import React, { Fragment } from 'react';

import Heading from 'components/text/Heading';
import Link from 'components/base/Link';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import Plus from 'assets/icons/Plus';
import PropTypes from 'prop-types';
import colors from 'config/theme/colors';
import styled from 'libs/styled';
import transitions from 'config/theme/transitions';
import withHeightAuto from 'utils/withHeightAuto';

const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 0;
`;

const InnerWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;

const AnimationWrapper = withHeightAuto(styled('div')`
    overflow: hidden;
`);

const SingleAccordion = ({
    anchorTag = '',
    animationDuration = 0,
    children,
    colorText = colors.black,
    handleClick,
    headerPX = '12px',
    headerPY = '16px',
    headingSize = 'sm',
    isActive = false,
    maxWithContent = false,
    text = '',
    timingFunction = 'linear',
    url = '',
    ...rest
}) => {
    // Add MaxWidthWrapper with includeContentMargins prop if maxWithContent is true
    const RenderMaxWidth = maxWithContent ? MaxWidthWrapper : Fragment;
    const RenderMaxWidthProps = maxWithContent ? { includeContentMargins: true } : {};

    return (
        <Wrapper color={colorText} id={anchorTag} {...rest}>
            <RenderMaxWidth {...RenderMaxWidthProps}>
                <Link volatile to={url || null} style={{ textDecoration: 'none' }}>
                    <InnerWrapper px={headerPX} py={headerPY} onClick={children && !url ? handleClick : null}>
                        <Heading as="h3" size={headingSize}>
                            {text}
                        </Heading>
                        {children && (
                            <Plus
                                color={colorText}
                                height="12px"
                                transform={isActive ? 'rotate(45deg)' : 'rotate(0)'}
                                transition={`transform ${transitions.primary}`}
                                width="12px"
                            />
                        )}
                    </InnerWrapper>
                </Link>
                {children && (
                    <AnimationWrapper
                        animationDuration={animationDuration}
                        height={isActive ? 'auto' : '0'}
                        transition={animationDuration > 0 && `${animationDuration}ms ${timingFunction}`}
                    >
                        {children}
                    </AnimationWrapper>
                )}
            </RenderMaxWidth>
        </Wrapper>
    );
};

SingleAccordion.propTypes = {
    anchorTag: PropTypes.string,
    animationDuration: PropTypes.number,
    children: PropTypes.node,
    colorText: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    headerPX: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    headerPY: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    headingSize: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    isActive: PropTypes.bool,
    maxWithContent: PropTypes.bool,
    text: PropTypes.string,
    timingFunction: PropTypes.string,
    url: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default SingleAccordion;
